import {Component} from "@angular/core";
import {MemberEntityModel} from "../../member-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";

@Component({
    selector: "wbo-member-edit-renewal",
    templateUrl: "./member-edit-renewal.component.html"
})
export class MemberEditRenewalComponent {
    constructor(public model: MemberEntityModel, public editService: EditService) {
    }

}
